import { environment } from '../../../environments/environment';
import type {
  LegalDocSlug,
  LegalDocumentItem,
  LegalDocumentKind,
  LegalPagedDocumentItem,
  LegalPagedDocumentKind,
  LegalProductConfig,
} from '../models/legal.model';

export const LEGAL_PRODUCTS: readonly LegalProductConfig[] = [
  { slug: 'catalog', accent: 'catalog', source: environment.api.host },
  { slug: 'core', accent: 'core', source: null },
];

export const LEGAL_DOC_KINDS: Readonly<Record<LegalDocSlug, LegalPagedDocumentKind>> = {
  terms: 'terms_of_service',
  privacy: 'privacy_policy',
  dpa: 'data_processing_agreement',
};

const LEGAL_KIND_TO_DOC_SLUG = Object.fromEntries(
  (Object.entries(LEGAL_DOC_KINDS) as [LegalDocSlug, LegalPagedDocumentKind][]).map(([slug, kind]) => [kind, slug]),
) as Readonly<Record<LegalPagedDocumentKind, LegalDocSlug>>;

export function legalProductBySlug(slug: string): LegalProductConfig | undefined {
  return LEGAL_PRODUCTS.find((product) => product.slug === slug);
}

export function legalKindByDocSlug(doc: string): LegalDocumentKind | undefined {
  return LEGAL_DOC_KINDS[doc as LegalDocSlug];
}

export function legalDocSlugByKind(kind: LegalPagedDocumentKind): LegalDocSlug {
  return LEGAL_KIND_TO_DOC_SLUG[kind];
}

export function legalDocumentHasPage(item: LegalDocumentItem): item is LegalPagedDocumentItem {
  return item.kind in LEGAL_KIND_TO_DOC_SLUG;
}
